import React, { Component, Fragment } from "react";
import Confirmation from "./Confirmation";
import CheckInButton from "./CheckInButton";
import ToggleCheckIn from "./ToggleCheckIn";
import { inject, observer } from "mobx-react";
import Select from "react-select";
import { getCurrency } from "../../services/cities";

@inject("CheckInStore", "RiderStore")
@observer
class RiderSection extends Component {
  state = {
    dispatchList: []
  };

  render() {
    const {
      CheckInStore,
      handleNext,
      handleSubmit,
      handleReturns
    } = this.props;

    return (
      <Fragment>
        {CheckInStore.currentPage === 2 && !CheckInStore.isSubmitted && (
          <div className={`${this.props.base}__section-area section-two`}>
            <div>
              <div className="display--flex" style={{ marginBottom: "28px" }}>
                <p className="center--vertical" style={{ fontSize: "18px" }}>
                  Return only
                </p>
                <ToggleCheckIn className="margin--left" />
              </div>
              <div className="display--flex">
                <div className="input display--flex">
                  <input
                    autoFocus
                    type="text"
                    placeholder="Bag number"
                    name="backpack_id"
                    value={CheckInStore.checkinData.backpack_id}
                    onChange={CheckInStore.handleChange}
                  />
                  {CheckInStore.checkinData.backpack_id && (
                    <p className="input-field-info">Bag</p>
                  )}
                </div>
                {CheckInStore.previous.current_backpack_id && (
                  <div className="previous-info">
                    <p>Previous</p>
                    <span>{CheckInStore.previous.current_backpack_id}</span>
                  </div>
                )}
              </div>
              <div className="display--flex">
                <div className="input display--flex">
                  <input
                    type="text"
                    placeholder="Cooler bag number"
                    name="cooler_bag_id"
                    value={CheckInStore.checkinData.cooler_bag_id}
                    onChange={CheckInStore.handleChange}
                  />
                  {CheckInStore.checkinData.cooler_bag_id && (
                    <p className="input-field-info">Cooler</p>
                  )}
                </div>
                {CheckInStore.previous.current_cooler_bag_id && (
                  <div className="previous-info">
                    <p>Previous</p>
                    <span>{CheckInStore.previous.current_cooler_bag_id}</span>
                  </div>
                )}
              </div>
              <div className="display--flex">
                <div className="input display--flex">
                  <div>
                    <p>{getCurrency()}</p>
                  </div>
                  <input
                    type="text"
                    placeholder="Cash on delivery"
                    name="returned_cash"
                    value={CheckInStore.checkinData.returned_cash}
                    onChange={CheckInStore.handleChange}
                  />
                  {CheckInStore.checkinData.returned_cash >= 0 &&
                    CheckInStore.checkinData.returned_cash !== "" && (
                      <p className="input-field-info">COD</p>
                    )}
                </div>
                {CheckInStore.previous.previous_route_cash_collected && (
                  <div className="previous-info">
                    <p>Cash collected on last route:</p>
                    <span>
                      {getCurrency()}{CheckInStore.previous.previous_route_cash_collected}
                    </span>
                  </div>
                )}
              </div>
              {CheckInStore.previous.previous_route_cash_collected && (
                <div
                  style={{
                    color: "red",
                    fontSize: "18px",
                    lineHeight: "20pt"
                  }}
                >
                  The rider has to return the exact cash amount. In case of
                  discrepancies inform your supervisor immediately!
                  <br />
                  <span
                    style={{
                      fontSize: "14px"
                    }}
                  >
                    Theft is punishable under Section 379 of the Penal Code
                    under Malaysian law with up to 7 years of prison and/or a
                    fine.
                  </span>
                </div>
              )}
            </div>
            <div>
              <div className="checkbox">
                <input
                  onChange={CheckInStore.handleCheck}
                  type="checkbox"
                  name="checklist_signed"
                  checked={CheckInStore.checkinData.checklist_signed}
                />
                <span>Checklist signed</span>
              </div>
            </div>
          </div>
        )}
        {CheckInStore.currentPage === 3 && !CheckInStore.isSubmitted && (
          <div className={`${this.props.base}__section-area`}>
            <Select
                value={CheckInStore.checkinData.dispatches}
                isMulti
                autoFocus
                required
                options={CheckInStore.dispatches}
                style={{ width: "523px", marginBottom: "10px" }}
                name="dispatches"
                onChange={options => {
                  CheckInStore.checkinData.dispatches = options;
                }}
            >
            </Select>
            <div>
              <div className="checkbox">
                <input
                  onChange={CheckInStore.handleCheck}
                  type="checkbox"
                  name="backup"
                  checked={CheckInStore.checkinData.backup}
                />
                <span>Backup route</span>
              </div>
            </div>
          </div>
        )}

        {CheckInStore.isSubmitted && <Confirmation {...this.props} />}

        <CheckInButton
          base={this.props.base}
          isDisabled={CheckInStore.isDisabled}
          handleNext={handleNext}
          handleSubmit={handleSubmit}
          handleReturns={handleReturns}
        />
      </Fragment>
    );
  }
}

export default RiderSection;



// WEBPACK FOOTER //
// ./src/components/checkIn/RiderSection.js